export default __webpack_public_path__ + "static/media/logo-ct-dark.bdbe0a2d.png";